import userHasPermission from '@webapp-next/lib/user-has-permission';
import {
  LIST_COLUMNS,
  getListColumnsPermissions,
  getColumnKeyByValue,
  ListColumnsKeys,
  ListColumnsNames,
} from '@/modules/people/definitions/people-list';

export default function checkListColumnPermissionsByColumnIndex(
  column: ListColumnsNames,
  permissionsMap?: Record<ListColumnsKeys, string[]>
): boolean {
  if (!column) {
    return false;
  }

  if (column === LIST_COLUMNS.LEAVE_BALANCE) {
    return userHasPermission('Can_Approve_Leave_Pay_Lines');
  }

  const columnPermissions = permissionsMap ?? getListColumnsPermissions();
  const permissions = columnPermissions[getColumnKeyByValue(column)] || [];

  for (const permission of permissions) {
    if (!userHasPermission(permission)) {
      return false;
    }
  }

  return true;
}
